import { Input } from '@parcel/ui';
import { Search } from 'lucide-react';
import type * as React from 'react';

interface FeedFiltersProps {
  query: string;
  onQueryChange: (query: string) => void;
  searchRef: React.RefObject<HTMLInputElement>;
}

/** The Feed's search: find a followed record by name. */
export function FeedFilters({ query, onQueryChange, searchRef }: FeedFiltersProps) {
  return (
    <div className="relative w-72">
      <Search
        className="pointer-events-none absolute left-3 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground"
        aria-hidden
      />
      <Input
        ref={searchRef}
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
        placeholder="Find an account or project..."
        aria-label="Find an account or project"
        className="h-9 rounded-full pl-9 pr-8 text-sm"
      />
      <kbd className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 rounded border px-1 text-[10px] text-muted-foreground">
        /
      </kbd>
    </div>
  );
}
